import { LocaleRouteMatcher } from "./locale-route-matcher";
import { RouteMatcher } from "./route-matcher";
export class PagesAPIRouteMatcher extends RouteMatcher {
}
export class PagesAPILocaleRouteMatcher extends LocaleRouteMatcher {
}

//# sourceMappingURL=pages-api-route-matcher.js.map